import type { RequiredDocumentDef } from '../utils/originationRequiredDocuments';

/** Single Uruguay basic-documentation catalog (no personería split). Task #52274 */
export const uruguayRequiredDocuments: RequiredDocumentDef[] = [
  {
    id: '001',
    value:
      'Breve reseña de la empresa (actividad, principales clientes, principales proveedores y demás información útil)',
  },
  {
    id: '009',
    value: 'Último Estado Contable certificado',
  },
  {
    id: '007',
    value: 'Manifestación de Bienes firmada por contador',
  },
  {
    id: '011',
    value: 'Estatuto de la empresa',
  },
  {
    id: '104',
    value: 'Formulario comercial',
  },
  {
    id: '105',
    value: 'Prenda',
  },
  {
    id: '106',
    value: 'Hipoteca',
  },
  {
    id: '107',
    value: 'Fianza',
  },
];
